export var EPaymentSource = /*#__PURE__*/function (EPaymentSource) {
  EPaymentSource[EPaymentSource["PhoneBalance"] = 1] = "PhoneBalance";
  EPaymentSource[EPaymentSource["BankCard"] = 2] = "BankCard";
  EPaymentSource[EPaymentSource["BankCardWithPreauth"] = 3] = "BankCardWithPreauth";
  EPaymentSource[EPaymentSource["SBP"] = 4] = "SBP";
  EPaymentSource[EPaymentSource["SberPay"] = 5] = "SberPay";
  EPaymentSource[EPaymentSource["Honeycombs"] = 6] = "Honeycombs";
  EPaymentSource[EPaymentSource["Oranges"] = 7] = "Oranges";
  return EPaymentSource;
}({});